import { useEffect, useState } from "react";

/**
 * Lets a regular mouse wheel scroll an element horizontally.
 * Trackpads and touch already scroll on X, so only vertical-dominant
 * wheel events on an overflowing element are translated.
 *
 * Returns a callback ref, so it also works when the element mounts later.
 *
 * @returns {(element: HTMLElement|null) => void}
 */
export const useHorizontalWheelScroll = () => {
  const [element, setElement] = useState(null);

  useEffect(() => {
    if (!element) return undefined;

    const onWheel = (event) => {
      const canScroll = element.scrollWidth > element.clientWidth;
      const isVertical = Math.abs(event.deltaY) > Math.abs(event.deltaX);

      if (!canScroll || !isVertical) return;

      event.preventDefault();
      element.scrollLeft += event.deltaY;
    };

    // Non-passive, otherwise preventDefault() is ignored
    element.addEventListener("wheel", onWheel, { passive: false });

    return () => element.removeEventListener("wheel", onWheel);
  }, [element]);

  return setElement;
};
